import PageLayout from "@/components/landing/PageLayout";
import { Sparkles, Bell } from "lucide-react";

export default function AIAdsPage() {
  return (
    <PageLayout testId="ai-ads-page-root">
      {({ openLead }) => (
        <section className="relative isolate overflow-hidden">
          <div className="hero-glow" aria-hidden />
          <div className="absolute inset-0 grid-pattern" aria-hidden />

          {/* radial fuchsia accent */}
          <div
            className="pointer-events-none absolute left-1/2 top-1/3 -z-10 h-[420px] w-[420px] -translate-x-1/2 rounded-full bg-fuchsia-600/20 blur-3xl"
            aria-hidden
          />

          <div className="relative mx-auto flex min-h-[70vh] max-w-4xl flex-col items-center justify-center px-5 py-24 text-center md:px-6">
            <div className="inline-flex items-center gap-2 rounded-full border border-fuchsia-400/30 bg-fuchsia-500/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-widest text-fuchsia-300">
              <Sparkles className="h-3.5 w-3.5" />
              AI Ads
            </div>

            <h1
              className="mt-6 font-display text-5xl font-extrabold leading-tight text-white sm:text-6xl lg:text-7xl"
              data-testid="ai-ads-title"
            >
              Coming <span className="bg-gradient-to-r from-fuchsia-300 via-purple-300 to-blue-300 bg-clip-text text-transparent">Soon</span>
            </h1>

            <p className="mt-6 max-w-xl text-base text-slate-300 sm:text-lg">
              We're building something powerful. AI-generated creatives, automated A/B testing and real-time optimisation — launching soon.
            </p>

            {/* animated dots */}
            <div className="mt-8 flex items-center gap-2" aria-hidden>
              <span className="h-2 w-2 animate-bounce rounded-full bg-fuchsia-400 [animation-delay:-0.3s]" />
              <span className="h-2 w-2 animate-bounce rounded-full bg-purple-400 [animation-delay:-0.15s]" />
              <span className="h-2 w-2 animate-bounce rounded-full bg-blue-400" />
            </div>

            <button
              type="button"
              onClick={() => openLead("AI Ads — waitlist", "Join the AI Ads waitlist")}
              className="btn-primary mt-10 inline-flex h-12 items-center gap-2 rounded-full px-6 text-sm font-semibold text-white"
              data-testid="ai-ads-notify-btn"
            >
              <Bell className="h-4 w-4" /> Notify me when it launches
            </button>
          </div>
        </section>
      )}
    </PageLayout>
  );
}
